import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Çeviriler
const resources = {
  tr: {
    translation: {
      'app': {
        'title': 'Alas Design Calculator',
        'subtitle': 'Aerosol Yangın Söndürme Sistemi Hesaplama Aracı',
        'language': 'Dil',
        'select_language': 'Dil Seçin',
        'footer_text': 'Tüm hakları saklıdır.',
      },
      'header': {
        'calculator': 'Hesaplama',
        'saved_rooms': 'Kaydedilenler',
        'help': 'Yardım',
        'search': 'Ara',
        'profile': 'Profil',
        'settings': 'Ayarlar',
        'logout': 'Çıkış Yap',
        'dealer_account': 'Bayi Hesabı',
        'login': 'Giriş Yap',
        'products': 'Ürünler',
        'parameters': 'Parametreler',
      },
      'parameters': {
        'title': 'Yangın Sınıfı Parametreleri',
        'subtitle': 'EN 15276-1 ve ISO 15779 standartlarına göre yangın sınıfları ve söndürme yoğunlukları',
        'fire_class_parameters': 'Yangın Sınıfları',
        'parameter': 'Parametre',
        'fire_class': 'Yangın Sınıfı',
        'material': 'Malzeme/Yakıt',
        'standards': 'Standart Test Numaraları',
        'suppression_info': 'Söndürme Bilgileri',
        'density': 'Söndürme Uygulama Yoğunluğu',
        'code': 'Kod',
        'id': 'No',
        'standards_info': 'Standart Bilgileri',
        'en_15276': 'EN 15276-1 Standardı',
        'en_15276_description': 'Sabit yangın söndürme sistemleri - Aerosol söndürme sistemleri',
        'standard_explanation': 'EN 15276-1 ve ISO 15779 standartları, aerosol yangın söndürme sistemlerinin tasarım, kurulum ve bakım gereksinimlerini belirler. Her yangın sınıfı için farklı söndürme yoğunlukları kullanılır.',
        'a_class_info': 'A Sınıfı yangınlar: Ahşap, kağıt, kumaş gibi katı yakıtlı yangınlar',
        'b_class_info': 'B Sınıfı yangınlar: Sıvı veya sıvılaşabilen katı yakıtlı yangınlar (benzin, yağ, vs.)',
        'parameter_report': 'Parametre Raporu ve Detaylı Analiz',
        'general_analysis': 'Genel Analiz',
        'analysis_description': 'Parametre sayfası, Alas Fire söndürme sistemlerinin tasarımında kullanılan yangın sınıflarına özgü temel verileri içerir. Bu parametreler, farklı malzeme türleri ve yakıtlar için EN 15276-1 ve ISO 15779 standartlarına dayanarak belirlenir. Her yangın sınıfı için söndürme yoğunluğu (gram/m³) ve test numaraları üzerinden genel değerlendirme yapılır. Bu veriler, özellikle emniyet faktörü (örn. 1.3) ile birlikte kullanıldığında doğru söndürücü miktarını belirlemek için sistem güvenilirliği ve etkinliğini optimize etmede kritik öneme sahiptir.',
        'parameter_scope': 'Parametre Kapsamı',
        'parameter_scope_description': 'Farklı yangın sınıfları için uygulanabilir parametreler şu şekildedir:\n\n• A Sınıfı Ahşap Deste (A.6.4, D.6.4): Ahşap destekli yapılar için optimize edilmiş parametre seti.\n• Genel Ahşap Deste (A.6.1, D.6.1): Daha geniş ahşap yangın senaryolarını kapsar.\n• A Sınıfı Polimer Levha (A.6.3, D.6.3): ABS, polipropilen ve PMMA gibi polimer malzemeler için uygundur.\n• B Sınıfı N-Heptan Sıvı (A.6.2, D.6.2): Sıvı yangınları (örn. yakıtlar) için tasarlanmıştır.\n\nBu parametreler, farklı oda tipleri ve yangın risk profilleri için esneklik sağlar.',
        'standards_section': 'Standartlar',
        'standards_section_description': 'Parametreler aşağıdaki uluslararası standartlara uygun olarak geliştirilmiştir:\n\n• EN 15276-1: Avrupa yangın söndürme sistemleri için test ve sertifika standartları.\n• ISO 15779: Yangın söndürme sistemlerinin tasarımı ve performansı için küresel olarak kabul görmüş standart.\n\nHer yangın sınıfı, bu standartlardaki test numaralarına dayalı doğrulama süreçlerinden geçmiştir (örn. A.6.1 ve D.6.1). Bu durum, Alas Fire sistemlerinin güvenilirliğini ve uyumluluğunu garanti eder.',
        'suppression_density': 'Söndürme Yoğunluğu',
        'suppression_density_description': 'Yangın sınıflarına göre gerekli söndürme yoğunluğu değerleri şu şekildedir:\n\n• A Sınıfı Ahşap Deste: 62 g/m³\n• A Sınıfı Ahşap Deste (Optimize): 49.75 g/m³ (daha düşük yoğunluk varyantı)\n• A Sınıfı Polimer Levha: 49.39 g/m³\n• B Sınıfı N-Heptan Sıvı: 74.89 g/m³\n\nBu yoğunluklar, oda hacmi ve emniyet faktörü ile çarpılarak gerekli söndürücü miktarını belirler (örn. 8 m³ × 62 g/m³ × 1.3 = 644.8 g).',
        'fire_class_distribution': 'Yangın Sınıfı Dağılımı',
        'fire_class_distribution_description': 'Yangın sınıflarının karşılaştırmalı analizi:\n\n• A Sınıfı Ahşap Deste (62 g/m³): Genel ahşap yangınları için daha yüksek yoğunluk gerektirir, daha fazla söndürücü kullanımını gösterir.\n• A Sınıfı Ahşap Deste (49.75 g/m³): Daha az söndürücü ile aynı etkinliği hedefleyen optimize edilmiş versiyon (örn. 2m x 2m x 2m oda için 517 g).\n• A Sınıfı Polimer Levha (49.39 g/m³): Polimer yangınlarına özgü, hafif yoğunluk farkı ile ayırt edilir.\n• B Sınıfı N-Heptan Sıvı (74.89 g/m³): Sıvı yangınlarının söndürülmesinin daha zor olması nedeniyle en yüksek yoğunluk değerine sahiptir.',
        'density_comparison': 'Yoğunluk Karşılaştırması',
        'density_comparison_description': 'Farklı yangın sınıfları için söndürme yoğunluğu karşılaştırması:\n\n• En Düşük Yoğunluk: 49.39 g/m³ (A Sınıfı Polimer Levha), malzeme tipine bağlı olarak daha az söndürücü gerektirir.\n• Ortalama Yoğunluk: 49.75 g/m³ (A Sınıfı Ahşap Deste Optimize) ve 62 g/m³ (Genel Ahşap Deste), ahşap yangınları için dengeli bir aralık sağlar.\n• En Yüksek Yoğunluk: 74.89 g/m³ (B Sınıfı N-Heptan Sıvı), sıvı yangınlarını kontrol etmek için maksimum yoğunluk sağlar.\n\nBu karşılaştırma, yangın sınıfı seçimi ve oda hacmi ile birlikte söndürücü miktarını belirlemede kritik bir faktördür.',
        'application_recommendation': 'Uygulama Önerileri',
        'application_recommendation_description': 'Yangın sınıfına göre optimum uygulama önerileri:\n\n• A Sınıfı Ahşap Deste (62 g/m³): Büyük ahşap depolar veya endüstriyel alanlar için IP 4600 veya IP 6100 gibi yüksek kapasiteli ürünler tercih edilmelidir.\n• A Sınıfı Ahşap Deste (49.75 g/m³): Küçük ve orta ölçekli ahşap destekli odalar (örn. 8 m³) için IP 530 veya IP 1400 uygundur; emniyet faktörü ile 517 g gibi düşük kütleler hedeflenebilir.\n• A Sınıfı Polimer Levha (49.39 g/m³): Polimer içeren ofisler veya depolar için IP 3500 gibi dengeli ürünler önerilir.\n• B Sınıfı N-Heptan Sıvı (74.89 g/m³): Yakıt depolama alanlarında sıvı yangınlarının hızla söndürülmesi için IP 6100 gibi yüksek kapasiteli ürünler idealdir.\n• Genel Öneri: Oda yüksekliği, montaj gereksinimlerine uygun ürün seçimi ile birleştirilmelidir (örn. 2m yükseklik için IP 530 veya IP 1400).',
      },
      'products': {
        'title': 'Ürünlerimiz',
        'subtitle': 'Alas Fire Aerosol Yangın Söndürme Ürünleri',
        'extinguishers': 'Söndürücüler',
        'controllers': 'Kontrol Üniteleri',
        'physical_properties': 'Fiziksel Özellikler',
        'weight': 'Ağırlık',
        'dimensions': 'Boyutlar',
        'contained_agent': 'İçerdiği Ajan',
        'effective_mass': 'Etkin Kütle',
        'mounting_info': 'Montaj Bilgileri',
        'min_height': 'Min. Yükseklik',
        'max_height': 'Maks. Yükseklik',
        'safe_distance': 'Güvenli Mesafe',
        'safe_distance_human': 'Aerosol söndürücü insana doğru yönlendirildiğinde güvenli mesafe',
        'suppression_capacities': 'Söndürme Kapasiteleri',
        'effective_volume': 'Etkin Hacim',
        'efficiency': 'Verimlilik',
        'model': 'Model',
        'id': 'ID',
        'controller': 'Kontrol Ünitesi',
        'controller_info': 'Kontrol Ünitesi Bilgileri',
        'max_extinguishers': 'Maks. Söndürücü Sayısı',
        'product_report': 'Ürün Raporu ve Detaylı Analiz',
        'general_analysis': 'Genel Analiz',
        'analysis_description': 'Alas Fire ürün yelpazesi, yoğunlaştırılmış aerosol yangın söndürme sistemleri için tasarlanmış bir dizi aerosol jeneratörü ve kontrol modülünü içerir. Bu ürünler, farklı yangın risk sınıflarına (A ve B sınıfları) yönelik olarak optimize edilmiştir ve geniş bir hacim aralığında etkili söndürme sağlar. Genel performans değerlendirmesi, ürünlerin kompakt tasarım sayesinde montaj kolaylığı sunma kapasitesine dayanır. IP serisi (IP 25\'ten IP 6100\'e kadar) yangın söndürme kapasitesini artırırken, AFS-CON1 kontrol modülü sistemin koordinasyonunu sağlar. Ürünler, ISO 15779 ve EN 15276 standartlarına uygun olarak test edilmiştir ve güvenilirlikleri saha denemeleriyle kanıtlanmıştır.',
        'product_scope': 'Ürün Kapsamı',
        'product_scope_description': 'Alas Fire ürün yelpazesi, yoğunlaştırılmış aerosol yangın söndürme sistemleri için tasarlanmış bir dizi aerosol jeneratörü ve kontrol modülünü içerir. Bu ürünler, farklı yangın risk sınıflarına (A ve B sınıfları) yönelik olarak optimize edilmiştir ve geniş bir hacim aralığında etkili söndürme sağlar. Genel performans değerlendirmesi, ürünlerin kompakt tasarım sayesinde montaj kolaylığı sunma kapasitesine dayanır. IP serisi (IP 25\'ten IP 6100\'e kadar) yangın söndürme kapasitesini artırırken, AFS-CON1 kontrol modülü sistemin koordinasyonunu sağlar. Ürünler, ISO 15779 ve EN 15276 standartlarına uygun olarak test edilmiştir ve güvenilirlikleri saha denemeleriyle kanıtlanmıştır.',
        'weight_range': 'Ürün Aralığı',
        'weight_range_description': 'Alas Fire ürünleri, çeşitli oda boyutları ve yangın sınıfları için esnek çözümler sunar:\n\n• Küçük Odalar (0.34 m³ - 16.88 m³): IP 25, IP 55 ve IP 110, küçük hacimli alanlar (örneğin, 2m x 2m x 2m gibi) için uygundur.\n• Orta Büyüklükteki Odalar (2.65 m³ - 73.57 m³): IP 220, IP 530, IP 1400, IP 2300 ve IP 3500, orta ölçekli odalar için ideal seçeneklerdir.\n• Büyük Odalar (55.48 m³ - 73.57 m³): IP 4600 ve IP 6100, geniş alanlarda (örneğin, 12m x 8m x 4m) etkili söndürme sağlar.\n• Yangın Sınıfları: A Sınıfı Katı Madde (Ahşap Deste, Polimer Levha) ve B Sınıfı Sıvı Madde (N-Heptan) yangınlarına yönelik kapasiteler, ürün seçimi için rehberdir.',
        'suppression_capacity': 'Sistem Entegrasyonu',
        'suppression_capacity_description': 'Ürünlerin ağırlık dağılımı, montaj gereksinimlerini ve taşıma kolaylığını etkiler:\n\n• Minimum Ağırlık: IP 25 (1 kg) küçük ve hafif bir seçenek sunar, düşük montaj gereksinimi ile öne çıkar.\n• Ortalama Ağırlık: IP 530\'dan IP 3500\'e kadar (3 kg - 26.5 kg), orta ölçekli uygulamalar için dengeli bir ağırlık aralığı sağlar.\n• Maksimum Ağırlık: IP 4600 (32 kg) ve IP 6100 (35.5 kg), büyük odalar için tasarlanmış olup, sağlam montaj yapıları gerektirir.\n• Montaj Gereksinimleri: Ürünlerin ağırlığı, montaj yüksekliği aralıklarına (90 cm - 600 cm) uygun destek yapıları gerektirir.',
        'mounting_safety': 'Söndürme Kapasitesi',
        'mounting_safety_description': 'Ürünlerin yangın sınıflarına göre söndürme kapasiteleri, etkin kütle ve tasarım yoğunluklarına (49.75 g/m³ için A Sınıfı, 74.89 g/m³ için B Sınıfı) dayanır:\n\n• IP 25: 0.34 m³ (A Sınıfı), 0.22 m³ (B Sınıfı)\n• IP 55: 0.62 m³ (A Sınıfı), 0.41 m³ (B Sınıfı)\n• IP 110: 1.24 m³ (A Sınıfı), 0.82 m³ (B Sınıfı)\n• IP 220: 2.65 m³ (A Sınıfı), 1.76 m³ (B Sınıfı)\n• IP 530: 7.46 m³ (A Sınıfı), 4.95 m³ (B Sınıfı)\n• IP 1400: 16.88 m³ (A Sınıfı), 11.22 m³ (B Sınıfı)\n• IP 2300: 27.74 m³ (A Sınıfı), 18.43 m³ (B Sınıfı)\n• IP 3500: 42.21 m³ (A Sınıfı), 28.04 m³ (B Sınıfı)\n• IP 4600: 55.48 m³ (A Sınıfı), 36.85 m³ (B Sınıfı)\n• IP 6100: 73.57 m³ (A Sınıfı), 48.87 m³ (B Sınıfı)\n\nBu kapasiteler, ürünün etkin kütlesinin ilgili yoğunluğa bölünmesiyle hesaplanır.',
        'calculation_formulas': 'Montaj Güvenliği',
        'calculation_formulas_description': 'Güvenli montaj için minimum ve maksimum yükseklik gereksinimleri:\n\n• IP 25 - IP 110: 90 cm - 100 cm (düşük profilli alanlar için ideal)\n• IP 220: 90 cm - 120 cm (orta seviye montaj)\n• IP 530: 120 cm - 350 cm (esnek montaj aralığı)\n• IP 1400: 150 cm - 286 cm (orta-yüksek alanlar)\n• IP 2300: 200 cm - 286 cm (yüksek alanlar)\n• IP 3500: 210 cm - 342 cm (yüksek tavanlar)\n• IP 4600: 230 cm - 450 cm (geniş aralık)\n• IP 6100: 250 cm - 600 cm (maksimum yükseklik desteği)\n\nBu aralıklar, ürünlerin test edilmiş güvenli mesafelerine dayanır ve yangın söndürme etkinliğini maksimize eder.',
        'product_dimensions': 'Ürün Boyutları',
        'controller_unit': 'Kontrol Ünitesi',
        'controller_description': 'AFS-CON1 kontrol ünitesi, söndürücülerin sıralı olarak tetiklenmesini sağlar. Kontrol ünitesi yangın söndürme kapasitesine sahip değildir.',
      },
      'common': {
        'clear': 'Temizle',
      },
      'login': {
        'title': 'Alas Design Calculator - Giriş',
        'username': 'Kullanıcı Adı',
        'username_placeholder': 'Bayi kullanıcı adınız',
        'password': 'Şifre',
        'password_placeholder': 'Şifreniz',
        'login_button': 'Giriş Yap',
        'login_loading': 'Giriş yapılıyor...',
        'form_title': 'Bayi Girişi',
        'form_description': 'Hesaplama aracına erişmek için bayi bilgilerinizle giriş yapın',
        'logging_in': 'Giriş yapılıyor...',
        'subtitle': 'Bayi hesabınızla giriş yaparak tasarım hesaplamalarına erişebilirsiniz.',
        'footer': 'Alas Fire bayileri için özel hesaplama aracı',
        'copyright': '© 2023 Alas Fire. Tüm hakları saklıdır.',
        'success_message': 'Giriş başarılı! Yönlendiriliyorsunuz...',
        'errors': {
          'required_username': 'Kullanıcı adı alanı zorunludur',
          'required_password': 'Şifre alanı zorunludur',
          'min_password': 'Şifre en az 6 karakter olmalı',
          'login_failed': 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.',
          'connection_failed': 'Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin.',
          'server_error': 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.',
          'invalid_response': 'Sunucudan geçersiz yanıt alındı.',
          'invalid_credentials': 'Geçersiz kullanıcı bilgileri. Lütfen bilgilerinizi kontrol edin.'
        }
      },
      'calculator': {
        'title': 'Hesaplama Aracı',
        'subtitle': 'Oda boyutlarını ve yangın sınıfını girerek gerekli söndürme kapasitesini hesaplayın',
        'dimensions': 'Oda Boyutları',
        'length': 'Uzunluk',
        'width': 'Genişlik',
        'height': 'Yükseklik',
        'length_placeholder': 'Uzunluk değerini metre cinsinden girin',
        'width_placeholder': 'Genişlik değerini metre cinsinden girin',
        'height_placeholder': 'Yükseklik değerini metre cinsinden girin',
        'fire_class': 'Yangın Sınıfı',
        'fire_class_a': 'A Sınıfı Ahşap Deste',
        'fire_class_b': 'B Sınıfı N-Heptan Sıvı',
        'fire_class_a_polymer': 'A Sınıfı Polimer Levha',
        'fire_class_wooden_general': 'Ahşap Deste (genel)',
        'safety_factor': 'Emniyet Faktörü',
        'safety_factor_placeholder': 'Emniyet faktörü değerini girin (min: 1.0)',
        'calculate_button': 'Hesapla',
        'calculate_with_selection': 'Seçilen Ürünlerle Hesapla',
        'select_products_first': 'Önce Ürün Seçimi Yapın',
        'calculating': 'Hesaplanıyor...',
        'results': 'Hesaplama Sonuçları',
        'volume': 'Oda Hacmi',
        'adjusted_volume': 'Ayarlanmış Hacim',
        'required_mass': 'Gerekli Söndürücü Miktarı',
        'cubic_meters': 'm³',
        'grams': 'g',
        'back_to_form': 'Forma Geri Dön',
        'no_results_yet': 'Henüz sonuç yok',
        'fill_form_to_calculate': 'Hesaplama yapmak için lütfen form bilgilerini doldurun ve "Hesapla" butonuna tıklayın',
        'selection_algorithms': 'Seçilen Ürünler',
        'selected_products': 'Seçilen Ürünler',
        'selection_explanation': 'Odanızın boyutlarına ve seçilen yangın sınıfına göre en uygun ürün kombinasyonları',
        'optimal': 'Optimum',
        'effective_mass': 'Etkin Kütle',
        'total_mass': 'Toplam Ağırlık',
        'extinguishing_capacity': 'Söndürme Kapasitesi',
        'mounting_height': 'Montaj Yüksekliği',
        'greedy_algorithm': 'Ürün Seçimi',
        'greedy_description': 'Optimal ürün kombinasyonu Excel hesap tablosuyla uyumlu',
        'manual_algorithm': 'Manuel Seçim',
        'product_selection_preferences': 'Ürün Seçimi Tercihleri',
        'selection_method': 'Seçim Yöntemi',
        'algorithm_preference_description': 'Hesaplama sonrasında kullanılacak ürün seçim algoritmasını seçin',
        'manual_selection_description': 'Hesaplamadan önce ürünleri manuel olarak seçin',
        'manual_selection_note': 'Manuel seçtiğiniz ürünlere göre hesaplama yapılacaktır',
        'selection_results': 'Seçim Sonuçları',
        'errors': {
          'required_field': 'Bu alan zorunludur',
          'positive_number': 'Lütfen pozitif bir sayı girin',
          'min_safety_factor': 'Emniyet faktörü 1\'den büyük veya eşit olmalı',
          'calculation_failed': 'Hesaplama başarısız, lütfen bilgilerinizi kontrol edin.',
          'connection_failed': 'Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin.',
          'server_error': 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.',
          'unauthorized': 'Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.',
          'insufficient_capacity': 'Söndürme kapasitesi odanın hacminden küçük olamaz.',
          'max_products_limit': 'Bir odada en fazla 3 farklı söndürücü kullanılabilir.',
          'max_extinguishers_limit': 'AFS-CON1 12\'den fazla söndürücüyü desteklemez.'
        },
        'form_title': 'Hesaplama Formu',
        'project_info': 'Proje Bilgileri',
        'project_name': 'Proje Adı',
        'project_name_placeholder': 'Projenin adını girin (örn: Resort Otel)',
        'region_name': 'Bölge Adı',
        'region_name_placeholder': 'Bölge adını girin (örn: Antalya)',
        'company_name': 'Firma Adı',
        'company_name_placeholder': 'Firma adını girin (örn: Alas Fire)',
        'room_name': 'Oda Adı',
        'room_name_placeholder': 'Odanın/alanın adını girin (örn: Akü Odası)',
        'calculation_params': 'Hesaplama Parametreleri',
        'fire_class_description': 'Yangın risk sınıfına göre gerekli söndürme yoğunluğu otomatik hesaplanır',
        'safety_factor_description': 'Varsayılan değer 1.3 olarak önerilir',
        'product_selection': 'Ürün Seçimi',
        'automatic_selection': 'Otomatik',
        'manual_selection': 'Manuel',
        'product_model': 'Ürün Modeli',
        'select_product': 'Ürün seçin',
        'quantity': 'Miktar',
        'quantity_placeholder': 'Ürün adedini girin (1-12 arası)',
        'add_button': 'Ekle',
        'remove_button': 'Kaldır',
        'add_product_error': 'Lütfen bir ürün modeli seçin ve geçerli bir miktar girin.',
        'invalid_product_error': 'Geçerli bir ürün seçilmedi.',
        'max_models_error': 'En fazla 3 farklı ürün modeli seçilebilir.',
        'max_quantity_error': 'Toplam ürün sayısı 12\'yi geçemez (AFS-CON1 limiti).',
        'please_add_product': 'Lütfen en az bir ürün ekleyin.',
        'mounting_height_error': 'Seçilen ürün bu oda yüksekliğinde kullanılamaz.',
        'total_extinguishers': 'Toplam Söndürücü:',
        'automatic_selection_description': 'Hesaplama sonucunda sistem en uygun ürün kombinasyonunu otomatik olarak belirleyecektir',
        'automatic_selection_results': 'Otomatik Seçim Sonuçları',
        'manual_selection_results': 'Manuel Seçim Sonuçları',
        'calculation_details': 'Hesaplama Detayları',
        'total_volume': 'Odanın Toplam Hacmi (m³)',
        'adjusted_volume_with_safety': 'Emniyet Faktörü ile Çarpılmış Hacim (m³)',
        'safety_factor_value': 'Emniyet Faktörü',
        'required_suppressant': 'Gerekli Söndürücü Miktarı (gram)',
        'suppression_density': 'Söndürme Yoğunluğu',
        'total_suppression_capacity': 'Seçilen Ürünlerin Toplam Söndürme Kapasitesi (m³)',
        'suppression_to_room_ratio': 'Söndürme/Oda Hacmi Oranı',
        'suppression_ratio': 'Söndürme Hacmi / Odanın Toplam Hacmi',
        'insufficient_capacity_warning': 'Uyarı: Söndürme kapasitesi yetersiz! Daha fazla ürün ekleyin.',
        'density_value': 'Söndürme Yoğunluğu (g/m³)',
        'verification_ratio': 'Doğrulama Oranı (%)',
        'summary': 'Özet',
        'total': 'Toplam',
        'no_products_selected': 'Henüz ürün seçilmedi',
        'show_details': 'Göster',
        'hide_details': 'Gizle',
        'physical_properties': 'Fiziksel Özellikler',
        'weight': 'Ağırlık',
        'dimensions_label': 'Boyutlar',
        'mounting_info': 'Montaj Bilgileri',
        'min_mount_height': 'Min. Montaj Yüksekliği',
        'max_mount_height': 'Maks. Montaj Yüksekliği',
        'suppression_capacities': 'Söndürme Kapasiteleri',
        'class_a': 'A Sınıfı',
        'class_b': 'B Sınıfı',
        'product_count': 'Adet',
        'product_total_mass': 'Toplam Kütle',
        'save_selection': 'Seçimi Kaydet',
        'total_effective_mass': 'Toplam Etkin Kütle',
        'save_room': 'Odayı Kaydet',
        'saved_rooms': 'Kaydedilmiş Odalar',
        'no_saved_rooms': 'Henüz kaydedilmiş oda yok.',
        'room_saved_date': 'Kaydedildi',
        'detail_button': 'Detay',
        'delete_button': 'Sil',
        'room_details': 'Oda Detayları',
        'close': 'Kapat',
        'project_report': 'Proje Raporu',
        'generate_report': 'Toplu Çıktı Al',
        'no_results': 'Hesaplama sonucu bulunamadı',
        'no_results_description': 'Hesaplama formu bilgilerini doldurup "Hesapla" butonuna tıklayın',
        'copy': 'Kopyala',
        'save': 'Kaydet',
        'export_excel': 'Excel\'e Aktar',
        'export_success': 'Rapor başarıyla indirildi!',
        'export_error': 'Rapor indirme sırasında bir hata oluştu.',
        'volume_exceeded': 'Oda hacmi 2000 m³\'ü geçemez.',
        'verification_failed': 'Yetersiz söndürme kapasitesi! Lütfen farklı ürün kombinasyonu deneyin.',
        'max_controller_exceeded': 'AFS-CON1 kontrol ünitesi maksimum 12 ürünü destekler.',
        'controller_added': 'AFS-CON1 kontrol ünitesi otomatik olarak eklendi.',
        'room': 'Oda',
        'no_name_room': 'İsimsiz Oda',
        'no_name_project': 'İsimsiz Proje',
        'status': 'Durum',
        'bulk_export_filename': 'Alas_Fire_Toplu_Rapor',
        'calculation_details': 'Hesaplama Detayları',
        'project_info': 'Proje Bilgileri',
        'selected_products': 'Seçilen Ürünler',
        'confirmations': {
          'duplicate_room_title': 'Oda Zaten Kayıtlı',
          'duplicate_room_description': 'Bu proje ve oda adı ile daha önce kayıt yapılmış. Mevcut kayıt farklı parametrelere sahip olabilir.',
          'update_existing_record': 'Mevcut Kaydı Güncelle',
          'create_new_record': 'Yeni Kayıt Ekle',
          'cancel': 'İptal',
          'delete_calculation': 'Bu hesaplamayı silmek istediğinizden emin misiniz?',
          'clear_all_calculations': 'Tüm kaydedilmiş hesaplamaları silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.'
        },
        'notifications': {
          'calculation_saved': 'Hesaplama başarıyla kaydedildi!',
          'calculation_updated': 'Hesaplama başarıyla güncellendi!',
          'save_failed': 'Hesaplama kaydedilemedi! Lütfen tekrar deneyin.',
          'calculation_deleted': 'Hesaplama başarıyla silindi!',
          'delete_failed': 'Hesaplama silinemedi! Lütfen tekrar deneyin.',
          'all_calculations_cleared': 'Tüm hesaplamalar başarıyla temizlendi!',
          'bulk_copy_success': 'Tüm hesaplamalar panoya kopyalandı!',
          'bulk_copy_error': 'Hesaplamalar kopyalanırken hata oluştu!',
          'no_calculations_to_copy': 'Kopyalanacak hesaplama bulunamadı!',
          'bulk_export_success': 'Tüm hesaplamalar Excel dosyasına aktarıldı!',
          'bulk_export_error': 'Excel dosyası oluşturulurken hata oluştu!',
          'no_calculations_to_export': 'Dışa aktarılacak hesaplama bulunamadı!',
          'room_already_exists': 'Bu proje ve oda adı zaten kayıtlı!',
          'no_results_to_save': 'Kaydedilecek hesaplama sonucu bulunamadı!',
          'invalid_manual_selection': 'Lütfen geçerli bir ürün ve miktar seçin!',
          'product_not_found': 'Seçilen ürün bulunamadı!',
          'verification_ratio_optimal': 'Doğrulama oranı optimal seviyede (%124-144 arası).',
          'results_copied': 'Sonuçlar panoya kopyalandı!',
          'calculation_cleared': 'Hesaplama başarıyla temizlendi!',
          'verification_ratio_too_high': 'Doğrulama oranı çok yüksek (%150\'den fazla). Ürün sayısını azaltmayı düşünün.',
          'verification_ratio_sufficient': 'Yeterli doğrulama oranı (%100 - %124).',
          'calculation_error': 'Hesaplama sırasında bir hata oluştu. Lütfen girdi bilgilerinizi ve oda parametrelerini kontrol edin.'
        },
        'product_names': {
          'IP_530': 'IP 530',
          'IP_370': 'IP 370',
          'IP_170': 'IP 170',
          'IP_100': 'IP 100',
          'IP_65': 'IP 65',
          'AFS_CON1': 'AFS-CON1'
        },
        'fire_class_options': {
          'a-wooden-stack': 'A Sınıfı Ahşap Deste',
          'b-nheptane-liquid': 'B Sınıfı N-Heptan Sıvı',
          'a-polymer-sheet': 'A Sınıfı Polimer Levha',
          'wooden-stack': 'Ahşap Deste'
        },
        // Direk yangın sınıfı key'leri
        'wooden-stack': 'Ahşap Deste',
        'a-polymer-sheet': 'A Sınıfı Polimer Levha',
        'b-nheptane-liquid': 'B Sınıfı N-Heptan Sıvı',
        'a-wooden-stack': 'A Sınıfı Ahşap Deste',
        'bulk_copy_template': {
          'room_number': '=== ROOM {{number}} ===',
          'header': '=== ALAS FIRE CALCULATION RESULTS ===',
          'dimensions': 'Room Dimensions: {{length}}m × {{width}}m × {{height}}m',
          'volume': 'Volume: {{volume}} m³',
          'adjusted_volume': 'Adjusted Volume: {{adjusted_volume}} m³',
          'safety_factor': 'Safety Factor: {{safety_factor}}',
          'fire_class': 'Fire Class: {{fire_class}}',
          'required_mass': 'Required Extinguisher: {{required_mass}} g',
          'product_selection_header': '=== PRODUCT SELECTION ===',
          'total_extinguishers': 'Total Extinguisher Count: {{count}}',
          'total_effective_mass': 'Total Effective Mass: {{mass}} g',
          'verification_ratio': 'Verification Ratio: {{ratio}}%',
          'calculation_date': 'Calculation Date: {{date}}'
        },
        'scroll_to_saved_rooms': 'Kaydedilen odalara git',
        'scroll_to_top': 'Sayfanın üstüne git',
        'no_products_selected': 'Ürün seçimi bulunamadı',
        'no_automatic_results': 'Otomatik hesaplama sonucu bulunamadı',
        'no_manual_products': 'Manuel ürün seçimi yapılmadı',
        'sufficient': 'Yeterli',
        'contained_agent': 'İçerdiği Ajan',
        'effective_mass_percentage': 'Etkin Kütle Yüzdesi',
        'class_a_capacity': 'A Sınıfı Kapasitesi',
        'class_b_capacity': 'B Sınıfı Kapasitesi',
        'min_height': 'Minimum Yükseklik',
        'max_height': 'Maksimum Yükseklik',
        'saved_calculations': 'Kaydedilmiş Hesaplamalar',
        'units': 'adet',
        'safe_distance': 'Güvenli Mesafe',
        'safe_distance_human': 'Aerosol söndürücü insana doğru yönlendirildiğinde güvenli mesafe',
        'view_details': 'Detayları Görüntüle',
        'fire_class_a_short': 'A Sınıfı Ahşap',
        'no_saved_calculations': 'Henüz kaydedilmiş hesaplama yok',
        'saved_calculation_count': '{{count}} kaydedilmiş oda',
        'saved_rooms_count': 'oda kaydedildi',
        'bulk_copy': 'Toplu Kopyala',
        'bulk_export': 'Toplu Excel',
        'clear_all': 'Tümünü Temizle',
        'room_details': 'Oda Detayları',
        'close': 'Kapat',
        'room_name': 'Oda Adı',
        'dimensions': 'Boyutlar',
        'adjusted_volume': 'Ayarlanmış Hacim',
        'required_extinguisher': 'Gerekli Söndürücü',
        'selected_products': 'Seçilen Ürünler',
        'total_mass': 'Toplam Kütle',
        'validation_ratio': 'Doğrulama Oranı',
        'unnamed_room': 'İsimsiz Oda',
        'unnamed_project': 'İsimsiz Proje',
        'calculation_date': 'Hesaplama Tarihi',
        'room_properties': 'Oda Özellikleri',
        'project_info': 'Proje Bilgileri',
        'region': 'Bölge',
        'company': 'Firma',
        'control_unit': 'Kontrol Ünitesi',
        'load_calculation': 'Hesaplamayı Yükle',
        // Kopyala ve Excel çıktıları için çeviriler
        'copyExport': {
          'calculation_results_title': 'ALAS FIRE CALCULATION RESULTS',
          'room_dimensions': 'Room Dimensions',
          'volume': 'Volume',
          'adjusted_volume': 'Adjusted Volume',
          'safety_factor': 'Safety Factor',
          'fire_class': 'Fire Class',
          'required_extinguisher': 'Required Extinguisher',
          'product_selection': 'PRODUCT SELECTION',
          'total_extinguisher_count': 'Total Extinguisher Count',
          'total_effective_mass': 'Total Effective Mass',
          'verification_ratio': 'Verification Ratio',
          'calculation_date': 'Calculation Date',
          'project': 'Project',
          'region': 'Region',
          'company': 'Company',
          'room': 'Room',
          'control_unit': 'Control Unit',
          'fire_classes': {
            'a-wooden-stack': 'Class A Wooden Stack',
            'b-nheptane-liquid': 'Class B N-Heptane Liquid',
            'a-polymer-sheet': 'Class A Polymer Sheet',
            'wooden-stack-general': 'Wooden Stack (General)'
          },
          'excel_titles': {
            'calculation_report': 'Calculation Report',
            'project_info': 'Project Information',
            'room_properties': 'Room Properties',
            'selected_products': 'Selected Products',
            'project_name': 'Project Name',
            'room_name': 'Room Name',
            'date': 'Date',
            'length': 'Length',
            'width': 'Width',
            'height': 'Height',
            'required_suppressant': 'Required Suppressant Amount',
            'product': 'Product',
            'quantity': 'Quantity',
            'unit_effective_mass': 'Unit Effective Mass (g)',
            'total_effective_mass': 'Total Effective Mass (g)',
            'total': 'Total',
            'suppression_capacity_control': 'Suppression Capacity Control',
            'verification_ratio': 'Verification Ratio',
            'report_footer': 'This report was generated by Alas Fire Design Calculator.',
            'summary': 'Summary'
          },
          'bulk_export': {
            'title': 'Alas Fire Bulk Calculation Report',
            'calculation_date': 'Calculation Date',
            'row_number': 'No.',
            'room_name': 'Room Name',
            'project_name': 'Project Name',
            'region': 'Region',
            'company': 'Company',
            'dimensions': 'Dimensions (m)',
            'volume': 'Volume (m³)',
            'fire_class': 'Fire Class',
            'required_amount': 'Required Amount (g)',
            'product_count': 'Product Count',
            'verification_ratio': 'Verification Ratio (%)',
            'date': 'Date'
          }
        }
      },
      'common': {
        'back': 'Geri',
        'clear': 'Temizle'
      },
      'privacy': {
        'title': 'Gizlilik Politikası',
        'introduction_title': 'Giriş',
        'introduction_content': 'Bu Gizlilik Politikası, ADC Makine Sanayi ve Ticaret Limited Şirketi ("Alas Fire", "biz", "bizim") tarafından sunulan Alas Design Calculator ("hizmet") kullanırken kişisel bilgilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklar. Bu hizmeti kullanarak, bu politikada açıklanan uygulamaları kabul etmiş olursunuz.',
        'data_collection_title': 'Veri Toplama',
        'data_collection_content': 'Hizmetimizi kullanırken aşağıdaki bilgileri toplayabiliriz:',
        'collected_data_title': 'Toplanan Veriler:',
        'collected_data_login': 'Giriş bilgileri (kullanıcı adı, şifre)',
        'collected_data_calculations': 'Hesaplama verileri (oda boyutları, yangın sınıfı, sonuçlar)',
        'collected_data_usage': 'Kullanım verileri (sayfa görüntülemeleri, özellik kullanımı)',
        'collected_data_technical': 'Teknik veriler (IP adresi, tarayıcı bilgileri, çerezler)',
        'data_usage_title': 'Veri Kullanımı',
        'data_usage_content': 'Toplanan veriler aşağıdaki amaçlarla kullanılır:',
        'usage_service': 'Hizmet sunumu ve hesaplama sonuçlarının sağlanması',
        'usage_security': 'Güvenlik ve kimlik doğrulama',
        'usage_improvement': 'Hizmet geliştirme ve optimizasyon',
        'usage_support': 'Teknik destek ve müşteri hizmetleri',
        'data_security_title': 'Veri Güvenliği',
        'data_security_content': 'Kişisel verilerinizi korumak için endüstri standardı güvenlik önlemleri kullanıyoruz. Veriler şifrelenmiş bağlantılar üzerinden iletilir ve güvenli sunucularda saklanır. Ancak, internet üzerinden veri iletiminin %100 güvenli olmadığını belirtmeliyiz.',
        'cookies_title': 'Çerezler',
        'cookies_content': 'Hizmetimiz, kullanıcı deneyimini iyileştirmek için çerezler kullanır:',
        'cookie_types_title': 'Çerez Türleri:',
        'cookie_essential': 'Gerekli çerezler: Oturum yönetimi ve güvenlik',
        'cookie_preferences': 'Tercih çerezleri: Dil seçimi ve kullanıcı ayarları',
        'cookie_analytics': 'Analitik çerezler: Kullanım istatistikleri (anonim)',
        'user_rights_title': 'Kullanıcı Hakları',
        'user_rights_content': 'KVKK kapsamında aşağıdaki haklara sahipsiniz:',
        'right_access': 'Kişisel verilerinize erişim hakkı',
        'right_correction': 'Yanlış verilerin düzeltilmesi hakkı',
        'right_deletion': 'Verilerin silinmesi hakkı',
        'right_portability': 'Veri taşınabilirliği hakkı',
        'right_object': 'İşlemeye itiraz etme hakkı',
        'third_parties_title': 'Üçüncü Taraflar',
        'third_parties_content': 'Kişisel verilerinizi üçüncü taraflarla paylaşmayız. Sadece hizmet sunumu için gerekli teknik sağlayıcılarla (barındırma, güvenlik) sınırlı veri paylaşımı yapabiliriz ve bu durumda uygun gizlilik anlaşmaları imzalanır.',
        'contact_title': 'İletişim',
        'contact_content': 'Gizlilik konularında sorularınız veya talepleriniz için bizimle iletişime geçebilirsiniz:',
        'updates_title': 'Politika Güncellemeleri',
        'updates_content': 'Bu Gizlilik Politikası gerektiğinde güncellenebilir. Önemli değişiklikler hizmet üzerinden bildirilecektir. Son güncelleme tarihi sayfanın altında belirtilmiştir.',
        'last_updated': 'Son Güncelleme'
      },
      'terms': {
        'title': 'Kullanım Koşulları',
        'introduction_title': 'Giriş',
        'introduction_content': 'Bu Kullanım Koşulları ("Koşullar"), ADC Makine Sanayi ve Ticaret Limited Şirketi ("Alas Fire", "şirket") tarafından sunulan Alas Design Calculator web uygulamasının ("hizmet") kullanımını düzenler. Hizmeti kullanarak bu koşulları kabul etmiş sayılırsınız.',
        'service_definition_title': 'Hizmet Tanımı',
        'service_definition_content': 'Alas Design Calculator, Alas Fire bayileri için aerosol yangın söndürme sistemlerinin hesaplanması amacıyla geliştirilmiş özel bir web uygulamasıdır.',
        'service_features_title': 'Hizmet Özellikleri:',
        'feature_calculation': 'Oda hacmi ve yangın sınıfına göre söndürücü hesaplaması',
        'feature_product_selection': 'Ürün seçimi ve optimizasyon algoritmaları',
        'feature_data_storage': 'Hesaplama sonuçlarının kaydedilmesi',
        'feature_reporting': 'Rapor oluşturma ve Excel çıktısı',
        'user_account_title': 'Kullanıcı Hesabı ve Kimlik Doğrulama',
        'user_account_content': 'Bu hizmet sadece yetkili Alas Fire bayileri tarafından kullanılabilir. Hesap erişimi için geçerli bayi kimlik bilgileri gereklidir.',
        'account_responsibilities_title': 'Hesap Sorumlulukları:',
        'responsibility_accuracy': 'Hesap bilgilerinin doğruluğundan sorumlusunuz',
        'responsibility_security': 'Giriş bilgilerinizi güvenli tutmakla yükümlüsünüz',
        'responsibility_unauthorized': 'Yetkisiz erişimi derhal bildirmelisiniz',
        'responsibility_compliance': 'Bu koşullara uygun kullanım sağlamalısınız',
        'service_usage_title': 'Hizmet Kullanımı',
        'service_usage_content': 'Hizmeti sadece yangın söndürme sistemi hesaplamaları için kullanabilirsiniz. Aşağıdaki faaliyetler yasaktır:',
        'prohibited_activities_title': 'Yasak Faaliyetler:',
        'prohibited_unauthorized': 'Yetkisiz erişim veya kullanım',
        'prohibited_reverse_engineer': 'Yazılımın tersine mühendisliği',
        'prohibited_commercial': 'Ticari olmayan amaçlarla kullanım',
        'prohibited_malicious': 'Zararlı kod veya virüs yükleme',
        'prohibited_data_extraction': 'Otomatik veri çıkarma veya botlar',
        'data_calculations_title': 'Veri ve Hesaplamalar',
        'data_calculations_content': 'Hesaplama sonuçları EN 15276-1 ve ISO 15779 standartlarına dayanır. Ancak, sonuçların doğruluğu girilen verilere bağlıdır.',
        'important_notice_title': 'Önemli Uyarı',
        'important_notice_content': 'Hesaplama sonuçları ön tasarım amaçlıdır. Nihai uygulama için profesyonel mühendislik değerlendirmesi gereklidir.',
        'intellectual_property_title': 'Fikri Mülkiyet',
        'intellectual_property_content': 'Bu hizmetin tüm fikri mülkiyet hakları ADC Makine Sanayi ve Ticaret Limited Şirketi\'ne aittir. Yazılım, algoritmalar, tasarım ve içerik telif hakkı koruması altındadır.',
        'disclaimer_title': 'Sorumluluk Reddi',
        'disclaimer_content': 'Hizmet "olduğu gibi" sunulur. Şirket, aşağıdaki konularda sorumluluk kabul etmez:',
        'liability_limitations_title': 'Sorumluluk Sınırlamaları:',
        'limitation_accuracy': 'Hesaplama sonuçlarının mutlak doğruluğu',
        'limitation_availability': 'Hizmetin kesintisiz erişilebilirliği',
        'limitation_compatibility': 'Tüm tarayıcılarla uyumluluk',
        'limitation_damages': 'Dolaylı veya sonuçsal zararlar',
        'service_changes_title': 'Hizmet Değişiklikleri',
        'service_changes_content': 'Şirket, hizmeti geliştirmek veya güncellemek amacıyla özellikler ekleyebilir, kaldırabilir veya değiştirebilir. Önemli değişiklikler kullanıcılara bildirilecektir.',
        'termination_title': 'Hesap Sonlandırma',
        'termination_content': 'Şirket, aşağıdaki durumlarda hesabınızı sonlandırma hakkını saklı tutar:',
        'termination_conditions_title': 'Sonlandırma Koşulları:',
        'termination_violation': 'Kullanım koşullarının ihlali',
        'termination_misuse': 'Hizmetin kötüye kullanımı',
        'termination_security': 'Güvenlik ihlalleri',
        'termination_legal': 'Yasal gereklilikler',
        'governing_law_title': 'Uygulanacak Hukuk',
        'governing_law_content': 'Bu koşullar Türkiye Cumhuriyeti yasalarına tabidir. Anlaşmazlıklar İstanbul mahkemelerinde çözümlenecektir.',
        'contact_title': 'İletişim',
        'contact_content': 'Bu koşullarla ilgili sorularınız için bizimle iletişime geçebilirsiniz:',
        'changes_title': 'Koşulların Değişikliği',
        'changes_content': 'Bu koşullar gerektiğinde güncellenebilir. Değişiklikler hizmet üzerinden duyurulur ve yürürlük tarihinden itibaren geçerli olur.',
        'last_updated': 'Son Güncelleme',
        'version': 'Versiyon'
      }
    }
  },
  en: {
    translation: {
      'app': {
        'title': 'Alas Design Calculator',
        'subtitle': 'Aerosol Fire Extinguishing System Calculation Tool',
        'language': 'Language',
        'select_language': 'Select Language',
        'footer_text': 'All rights reserved.',
      },
      'header': {
        'calculator': 'Calculator',
        'saved_rooms': 'Saved',
        'help': 'Help',
        'search': 'Search',
        'profile': 'Profile',
        'settings': 'Settings',
        'logout': 'Logout',
        'dealer_account': 'Dealer Account',
        'login': 'Login',
        'products': 'Products',
        'parameters': 'Parameters',
      },
      'parameters': {
        'title': 'Fire Class Parameters',
        'subtitle': 'Fire classes and suppression densities according to EN 15276-1 and ISO 15779 standards',
        'fire_class_parameters': 'Fire Classes',
        'parameter': 'Parameter',
        'fire_class': 'Fire Class',
        'material': 'Material/Fuel',
        'standards': 'Standard Test Numbers',
        'suppression_info': 'Suppression Information',
        'density': 'Suppression Application Density',
        'code': 'Code',
        'id': 'No',
        'standards_info': 'Standard Information',
        'en_15276': 'EN 15276-1 Standard',
        'en_15276_description': 'Fixed fire extinguishing systems - Aerosol extinguishing systems',
        'standard_explanation': 'EN 15276-1 and ISO 15779 standards define the design, installation and maintenance requirements for aerosol fire extinguishing systems. Different suppression densities are used for each fire class.',
        'a_class_info': 'Class A fires: Solid fuel fires such as wood, paper, fabric',
        'b_class_info': 'Class B fires: Liquid or liquefiable solid fuel fires (gasoline, oil, etc.)',
        'parameter_report': 'Parameter Report and Detailed Analysis',
        'general_analysis': 'General Analysis',
        'analysis_description': 'The parameter page contains essential data specific to fire classes used in the design of Alas Fire suppression systems. These parameters are determined based on EN 15276-1 and ISO 15779 standards for different material types and fuels. General evaluation is made through suppression density (gram/m³) and test numbers for each fire class. This data is critical for optimizing system reliability and effectiveness, especially when used with safety factor (e.g., 1.3) to determine the correct amount of extinguisher.',
        'parameter_scope': 'Parameter Scope',
        'parameter_scope_description': 'Applicable parameters for different fire classes are as follows:\n\n• Class A Wooden Stack (A.6.4, D.6.4): A parameter set optimized for wooden-supported structures.\n• General Wooden Stack (A.6.1, D.6.1): Covers broader wooden fire scenarios.\n• Class A Polymer Sheet (A.6.3, D.6.3): Suitable for polymer materials such as ABS, polypropylene and PMMA.\n• Class B N-Heptane Liquid (A.6.2, D.6.2): Designed for liquid fires (e.g., fuels).\n\nThese parameters provide flexibility for different room types and fire risk profiles.',
        'standards_section': 'Standards',
        'standards_section_description': 'Parameters have been developed in accordance with the following international standards:\n\n• EN 15276-1: Test and certification standards for European fire suppression systems.\n• ISO 15779: A globally accepted standard for the design and performance of fire suppression systems.\n\nEach fire class has undergone validation processes based on test numbers in these standards (e.g., A.6.1 and D.6.1). This guarantees the reliability and compliance of Alas Fire systems.',
        'suppression_density': 'Suppression Density',
        'suppression_density_description': 'Required suppression density values by fire class are as follows:\n\n• Class A Wooden Stack: 62 g/m³\n• Class A Wooden Stack (Optimized): 49.75 g/m³ (a lower density variant)\n• Class A Polymer Sheet: 49.39 g/m³\n• Class B N-Heptane Liquid: 74.89 g/m³\n\nThese densities determine the required amount of extinguisher by multiplying with room volume and safety factor (e.g., 8 m³ × 62 g/m³ × 1.3 = 644.8 g).',
        'fire_class_distribution': 'Fire Class Distribution',
        'fire_class_distribution_description': 'Comparative analysis of fire classes:\n\n• Class A Wooden Stack (62 g/m³): Requires higher density for general wood fires, indicating more extinguisher usage.\n• Class A Wooden Stack (49.75 g/m³): An optimized version that targets the same effectiveness with less extinguisher (e.g., 517 g for a 2m x 2m x 2m room).\n• Class A Polymer Sheet (49.39 g/m³): Specific to polymer fires, distinguished by a slight density difference.\n• Class B N-Heptane Liquid (74.89 g/m³): Has the highest density value due to the more difficult to extinguish nature of liquid fires.',
        'density_comparison': 'Density Comparison',
        'density_comparison_description': 'Comparison of suppression densities for different fire classes:\n\n• Lowest Density: 49.39 g/m³ (Class A Polymer Sheet), requires less extinguisher depending on material type.\n• Average Density: 49.75 g/m³ (Class A Wooden Stack Optimized) and 62 g/m³ (General Wooden Stack), provides a balanced range for wood fires.\n• Highest Density: 74.89 g/m³ (Class B N-Heptane Liquid), provides maximum density for controlling liquid fires.\n\nThis comparison is a critical factor in determining the amount of extinguisher along with the selection of fire class and room volume.',
        'application_recommendation': 'Application Recommendations',
        'application_recommendation_description': 'Optimal application recommendations by fire class:\n\n• Class A Wooden Stack (62 g/m³): High-capacity products like IP 4600 or IP 6100 should be preferred for large wooden warehouses or industrial areas.\n• Class A Wooden Stack (49.75 g/m³): IP 530 or IP 1400 are suitable for small and medium-scale wooden-supported rooms (e.g., 8 m³); low masses like 517 g can be targeted with safety factor.\n• Class A Polymer Sheet (49.39 g/m³): Balanced products like IP 3500 are recommended for polymer-containing offices or warehouses.\n• Class B N-Heptane Liquid (74.89 g/m³): High-capacity products like IP 6100 are ideal for rapid extinguishing of liquid fires in fuel storage areas.\n• General Recommendation: Room height should be combined with product selection suitable for installation requirements (e.g., IP 530 or IP 1400 for 2m height).',
      },
      'products': {
        'title': 'Our Products',
        'subtitle': 'Alas Fire Aerosol Fire Extinguishing Products',
        'extinguishers': 'Extinguishers',
        'controllers': 'Control Units',
        'physical_properties': 'Physical Properties',
        'weight': 'Weight',
        'dimensions': 'Dimensions',
        'contained_agent': 'Contained Agent',
        'effective_mass': 'Effective Mass',
        'mounting_info': 'Mounting Information',
        'min_height': 'Min. Height',
        'max_height': 'Max. Height',
        'safe_distance': 'Safe Distance',
        'safe_distance_human': 'Safe distance when aerosol extinguisher is directed towards a person',
        'suppression_capacities': 'Suppression Capacities',
        'effective_volume': 'Effective Volume',
        'efficiency': 'Efficiency',
        'model': 'Model',
        'id': 'ID',
        'controller': 'Controller',
        'controller_info': 'Controller Information',
        'max_extinguishers': 'Max. Extinguishers',
        'product_report': 'Product Report and Detailed Analysis',
        'general_analysis': 'General Analysis',
        'controller_description': 'The AFS-CON1 control unit enables sequential activation of extinguishers. The control unit does not have any fire suppression capacity.',
        'controller_unit': 'Controller Unit',
        'analysis_description': 'Alas Fire product range includes a series of aerosol generators and control modules designed for concentrated aerosol fire suppression systems. These products are optimized for different fire risk classes (Classes A and B) and provide effective suppression across a wide volume range. General performance evaluation is based on the products\' ability to provide easy installation thanks to compact design. IP series (from IP 25 to IP 6100) increases fire suppression capacity, while AFS-CON1 control module provides system coordination. Products are tested according to ISO 15779 and EN 15276 standards and their reliability has been proven through field tests.',
        'product_scope': 'Product Scope',
        'product_scope_description': 'Alas Fire product range includes a series of aerosol generators and control modules designed for concentrated aerosol fire suppression systems. These products are optimized for different fire risk classes (Classes A and B) and provide effective suppression across a wide volume range. General performance evaluation is based on the products\' ability to provide easy installation thanks to compact design. IP series (from IP 25 to IP 6100) increases fire suppression capacity, while AFS-CON1 control module provides system coordination. Products are tested according to ISO 15779 and EN 15276 standards and their reliability has been proven through field tests.',
        'weight_range': 'Product Range',
        'weight_range_description': 'Alas Fire products offer flexible solutions for various room sizes and fire classes:\n\n• Small Rooms (0.34 m³ - 16.88 m³): IP 25, IP 55 and IP 110 are suitable for small volume areas (e.g., 2m x 2m x 2m).\n• Medium-sized Rooms (2.65 m³ - 73.57 m³): IP 220, IP 530, IP 1400, IP 2300 and IP 3500 are ideal options for medium-scale rooms.\n• Large Rooms (55.48 m³ - 73.57 m³): IP 4600 and IP 6100 provide effective suppression in large areas (e.g., 12m x 8m x 4m).\n• Fire Classes: Class A Solid Materials (Wooden Stack, Polymer Sheet) and Class B Liquid Materials (N-Heptane) fire capacities serve as a guide for product selection.',
        'suppression_capacity': 'System Integration',
        'suppression_capacity_description': 'Product weight distribution affects installation requirements and ease of transport:\n\n• Minimum Weight: IP 25 (1 kg) offers a small and lightweight option, standing out with low installation requirements.\n• Average Weight: IP 530 to IP 3500 (3 kg - 26.5 kg) provides a balanced weight range for medium-scale applications.\n• Maximum Weight: IP 4600 (32 kg) and IP 6100 (35.5 kg) are designed for large rooms and require robust mounting structures.\n• Installation Requirements: Product weight requires support structures suitable for mounting height ranges (90 cm - 600 cm).',
        'mounting_safety': 'Suppression Capacity',
        'mounting_safety_description': 'Products\' suppression capacities by fire classes are based on effective mass and design densities (49.75 g/m³ for Class A, 74.89 g/m³ for Class B):\n\n• IP 25: 0.34 m³ (Class A), 0.22 m³ (Class B)\n• IP 55: 0.62 m³ (Class A), 0.41 m³ (Class B)\n• IP 110: 1.24 m³ (Class A), 0.82 m³ (Class B)\n• IP 220: 2.65 m³ (Class A), 1.76 m³ (Class B)\n• IP 530: 7.46 m³ (Class A), 4.95 m³ (Class B)\n• IP 1400: 16.88 m³ (Class A), 11.22 m³ (Class B)\n• IP 2300: 27.74 m³ (Class A), 18.43 m³ (Class B)\n• IP 3500: 42.21 m³ (Class A), 28.04 m³ (Class B)\n• IP 4600: 55.48 m³ (Class A), 36.85 m³ (Class B)\n• IP 6100: 73.57 m³ (Class A), 48.87 m³ (Class B)\n\nThese capacities are calculated by dividing the product\'s effective mass by the relevant density.',
        'calculation_formulas': 'Installation Safety',
        'calculation_formulas_description': 'Minimum and maximum height requirements for safe installation:\n\n• IP 25 - IP 110: 90 cm - 100 cm (ideal for low-profile areas)\n• IP 220: 90 cm - 120 cm (medium-level installation)\n• IP 530: 120 cm - 350 cm (flexible installation range)\n• IP 1400: 150 cm - 286 cm (medium-high areas)\n• IP 2300: 200 cm - 286 cm (high areas)\n• IP 3500: 210 cm - 342 cm (high ceilings)\n• IP 4600: 230 cm - 450 cm (wide range)\n• IP 6100: 250 cm - 600 cm (maximum height support)\n\nThese ranges are based on the products\' tested safe distances and maximize fire suppression effectiveness.',
        'product_dimensions': 'Product Dimensions',
        'controller_unit': 'Controller Unit',
        'controller_description': 'The AFS-CON1 control unit enables sequential activation of extinguishers. The control unit does not have any fire suppression capacity.',
      },
      'common': {
        'clear': 'Clear',
      },
      'login': {
        'title': 'Alas Design Calculator - Login',
        'username': 'Username',
        'username_placeholder': 'Your dealer username',
        'password': 'Password',
        'password_placeholder': 'Your password',
        'login_button': 'Login',
        'login_loading': 'Logging in...',
        'form_title': 'Dealer Login',
        'form_description': 'Log in with your dealer credentials to access the calculation tool',
        'logging_in': 'Logging in...',
        'subtitle': 'Log in with your dealer account to access design calculations.',
        'footer': 'Special calculation tool for Alas Fire dealers',
        'copyright': '© 2023 Alas Fire. All rights reserved.',
        'success_message': 'Login successful! Redirecting...',
        'errors': {
          'required_username': 'Username field is required',
          'required_password': 'Password field is required',
          'min_password': 'Password must be at least 6 characters',
          'login_failed': 'Login failed. Please check your credentials.',
          'connection_failed': 'Could not connect to server. Please check your internet connection.',
          'server_error': 'Server error. Please try again later.',
          'invalid_response': 'Invalid response received from server.',
          'invalid_credentials': 'Invalid login credentials. Please check your information.'
        }
      },
      'calculator': {
        'title': 'Calculation Tool',
        'subtitle': 'Calculate required suppression capacity by entering room dimensions and fire class',
        'dimensions': 'Room Dimensions',
        'length': 'Length',
        'width': 'Width',
        'height': 'Height',
        'length_placeholder': 'Enter length in meters',
        'width_placeholder': 'Enter width in meters',
        'height_placeholder': 'Enter height in meters',
        'fire_class': 'Fire Class',
        'fire_class_a': 'Class A Compatible Wood Crib Test',
        'fire_class_b': 'N-Heptane Pan Fire Test',
        'fire_class_a_polymer': 'Polymeric Sheet Fire Test',
        'fire_class_wooden_general': 'Wood Crib Fire Test',
        'safety_factor': 'Safety Factor',
        'safety_factor_placeholder': 'Enter safety factor value (min: 1.0)',
        'calculate_button': 'Calculate',
        'calculate_with_selection': 'Calculate with Selected Products',
        'select_products_first': 'Select Products First',
        'calculating': 'Calculating...',
        'results': 'Calculation Results',
        'volume': 'Room Volume',
        'adjusted_volume': 'Adjusted Volume',
        'required_mass': 'Required Suppressant',
        'cubic_meters': 'm³',
        'grams': 'g',
        'back_to_form': 'Back to Form',
        'no_results_yet': 'No results yet',
        'fill_form_to_calculate': 'Please fill in the form and click the "Calculate" button to perform calculation',
        'selection_algorithms': 'Selected Products',
        'selected_products': 'Selected Products',
        'selection_explanation': 'Most suitable product combinations for your room dimensions and selected fire class',
        'optimal': 'Optimal',
        'effective_mass': 'Effective Mass',
        'total_mass': 'Total Weight',
        'extinguishing_capacity': 'Extinguishing Capacity',
        'mounting_height': 'Mounting Height',
        'greedy_algorithm': 'Product Selection',
        'greedy_description': 'Optimal product combination compatible with Excel spreadsheet',
        'manual_algorithm': 'Manual Selection',
        'product_selection_preferences': 'Product Selection Preferences',
        'selection_method': 'Selection Method',
        'algorithm_preference_description': 'Select the product selection algorithm to be used after calculation',
        'manual_selection_description': 'Manually select products before calculation',
        'manual_selection_note': 'Calculation will be based on the products you manually select',
        'selection_results': 'Selection Results',
        'errors': {
          'required_field': 'This field is required',
          'positive_number': 'Please enter a positive number',
          'min_safety_factor': 'Safety factor must be greater than or equal to 1',
          'calculation_failed': 'Calculation failed, please check your information.',
          'connection_failed': 'Could not connect to server. Please check your internet connection.',
          'server_error': 'Server error. Please try again later.',
          'unauthorized': 'Your session has expired. Please login again.',
          'insufficient_capacity': 'Extinguishing capacity cannot be less than room volume.',
          'max_products_limit': 'A maximum of 3 different extinguishers can be used in a room.',
          'max_extinguishers_limit': 'AFS-CON1 does not support more than 12 extinguishers.'
        },
        'form_title': 'Calculation Form',
        'project_info': 'Project Information',
        'project_name': 'Project Name',
        'project_name_placeholder': 'Enter project name (e.g., Resort Hotel)',
        'region_name': 'Region Name',
        'region_name_placeholder': 'Enter region name (e.g., Antalya)',
        'company_name': 'Company Name',
        'company_name_placeholder': 'Enter company name (e.g., Alas Fire)',
        'room_name': 'Room Name',
        'room_name_placeholder': 'Enter room/area name (e.g., Battery Room)',
        'calculation_params': 'Calculation Parameters',
        'fire_class_description': 'Required suppression density is automatically calculated according to the fire risk class',
        'safety_factor_description': 'Default value 1.3 is recommended',
        'product_selection': 'Product Selection',
        'automatic_selection': 'Automatic',
        'manual_selection': 'Manual',
        'product_model': 'Product Model',
        'select_product': 'Select product',
        'quantity': 'Quantity',
        'quantity_placeholder': 'Enter product quantity (1-12)',
        'add_button': 'Add',
        'remove_button': 'Remove',
        'add_product_error': 'Please select a product model and enter a valid quantity.',
        'invalid_product_error': 'No valid product selected.',
        'max_models_error': 'Maximum 3 different product models can be selected.',
        'max_quantity_error': 'Total product count cannot exceed 12 (AFS-CON1 limit).',
        'please_add_product': 'Please add at least one product.',
        'mounting_height_error': 'Selected product cannot be used at this room height.',
        'total_extinguishers': 'Total Extinguishers:',
        'automatic_selection_description': 'After calculation, the system will automatically determine the most suitable product combination',
        'automatic_selection_results': 'Automatic Selection Results',
        'manual_selection_results': 'Manual Selection Results',
        'calculation_details': 'Calculation Details',
        'total_volume': 'Total Room Volume (m³)',
        'adjusted_volume_with_safety': 'Volume Multiplied by Safety Factor (m³)',
        'safety_factor_value': 'Safety Factor',
        'required_suppressant': 'Required Suppressant',
        'suppression_density': 'Suppression Density',
        'total_suppression_capacity': 'Total Suppression Capacity of Selected Products (m³)',
        'suppression_to_room_ratio': 'Suppression/Room Volume Ratio',
        'suppression_ratio': 'Suppression Volume / Total Room Volume',
        'insufficient_capacity_warning': 'Warning: Insufficient suppression capacity! Add more products.',
        'density_value': 'Suppression Density (g/m³)',
        'verification_ratio': 'Verification Ratio (%)',
        'summary': 'Summary',
        'total': 'Total',
        'no_products_selected': 'No products selected yet',
        'show_details': 'Show',
        'hide_details': 'Hide',
        'physical_properties': 'Physical Properties',
        'weight': 'Weight',
        'dimensions_label': 'Dimensions',
        'mounting_info': 'Mounting Information',
        'min_mount_height': 'Min. Mounting Height',
        'max_mount_height': 'Max. Mounting Height',
        'suppression_capacities': 'Suppression Capacities',
        'class_a': 'Class A',
        'class_b': 'Class B',
        'product_count': 'Quantity',
        'product_total_mass': 'Total Mass',
        'save_selection': 'Save Selection',
        'total_effective_mass': 'Total Effective Mass',
        'save_room': 'Save Room',
        'saved_rooms': 'Saved Rooms',
        'no_saved_rooms': 'No saved rooms yet.',
        'room_saved_date': 'Saved',
        'detail_button': 'Detail',
        'delete_button': 'Delete',
        'room_details': 'Room Details',
        'close': 'Close',
        'project_report': 'Project Report',
        'generate_report': 'Generate Bulk Output',
        'no_results': 'No calculation results found',
        'no_results_description': 'Fill in the calculation form and click the "Calculate" button',
        'copy': 'Copy',
        'save': 'Save',
        'export_excel': 'Export to Excel',
        'export_success': 'Report successfully downloaded!',
        'export_error': 'An error occurred while downloading the report.',
        'volume_exceeded': 'Room volume must not exceed 2000 m³.',
        'verification_failed': 'Insufficient suppression capacity! Please try a different product combination.',
        'max_controller_exceeded': 'AFS-CON1 control unit supports a maximum of 12 products.',
        'controller_added': 'AFS-CON1 control unit automatically added.',
        'room': 'Room',
        'no_name_room': 'Unnamed Room',
        'no_name_project': 'Unnamed Project',
        'status': 'Status',
        'bulk_export_filename': 'Alas_Fire_Bulk_Report',
        'calculation_details': 'Calculation Details',
        'project_info': 'Project Information',
        'selected_products': 'Selected Products',

        'errors': {
          'calculation_failed': 'Calculation process failed',
          'positive_number': 'Please enter a positive number',
          'algorithm_not_found': 'Selected algorithm not found',
          'no_selections': 'No product selections found',
                      'no_products_selected': 'Please select at least one product',
            'verification_ratio_optimal': 'Verification ratio is at optimal level (124%-144%).',
            'verification_ratio_too_high': 'Verification ratio is too high (over 150%). Consider reducing the number of products.',
          'invalid_product': 'Invalid product selection',
          'max_product_types': 'You can select a maximum of 3 different product models',
          'select_product': 'Please select a product model',
          'invalid_quantity': 'Invalid quantity (must be between 1-12)',
          'calculation_error': 'An error occurred during calculation',
          'missing_room_parameters': 'Please enter all room parameters',
          'room_too_large': 'Room volume can be maximum 2000 m³',
          'result_processing_error': 'An error occurred while processing results',
          'server_error': 'Server error oluştu. Lütfen daha sonra tekrar deneyin.',
          'connection_failed': 'Bağlantı hatası. İnternet bağlantınızı kontrol edin.',
          'unauthorized': 'Giriş yapmanız gerekiyor',
          'access_denied': 'Erişim reddedildi',
          'missing_fields': 'Lütfen tüm alanları doldurun',
          'invalid_credentials': 'Geçersiz kullanıcı adı veya şifre',
          'session_expired': 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.',
          'required_field': 'Bu alan zorunludur',
          'min_safety_factor': 'Emniyet faktörü en az 1.0 olmalıdır',
          'invalid_dimensions': 'Geçersiz oda boyutları',
          'invalid_safety_factor': 'Geçersiz emniyet faktörü',
          'volume_exceeded': 'Oda hacmi maksimum 2000 m³ olabilir',
          'missing_room_parameters': 'Lütfen tüm oda parametrelerini girin',
          'no_products_selected': 'Lütfen en az bir ürün seçin',
          'verification_ratio_too_low': 'Doğrulama oranı yetersiz (%100\'den az). Daha fazla ürün ekleyin veya oda boyutlarını kontrol edin.',
          'verification_ratio_optimal': 'Doğrulama oranı optimal seviyede (%124-144 arası).',
          'verification_ratio_too_high': 'Doğrulama oranı çok yüksek (%150\'den fazla). Ürün sayısını azaltmayı düşünün.',
          'height_incompatible_products': 'Şu ürünler belirtilen oda yüksekliğine uygun değil: {{products}}',
          'too_many_extinguishers': 'En fazla {{limit}} söndürücü seçilebilir. Şu anda {{count}} adet seçtiniz.',
          'too_many_models': 'En fazla {{limit}} farklı model seçilebilir. Şu anda {{count}} farklı model seçtiniz.',
          'invalid_selection': 'Geçersiz ürün seçimi'
        },
        'contained_agent': 'Contained Agent',
        'effective_mass_percentage': 'Effective Mass Percentage',
        'class_a_capacity': 'Class A Capacity',
        'class_b_capacity': 'Class B Capacity',
        'min_height': 'Minimum Height',
        'max_height': 'Maximum Height',
        'total_fire_class_effective_mass': 'Total Suppression Effective Mass of Selected Products for the Specified Fire Risk Class',
        'clear_all': 'Clear All',
        'bulk_copy_header': 'ALAS FIRE SAVED ROOMS REPORT',
        'bulk_export_title': 'Bulk Calculation Report',
        'fire_class_b_short': 'Class B N-Heptane',
        'fire_class_a_polymer_short': 'Class A Polymer',
        'fire_class_wooden_short': 'Wood (General)',
        'confirmations': {
          'duplicate_room_title': 'Room Already Exists',
          'duplicate_room_description': 'A record with this project and room name has been saved before. The existing record may have different parameters.',
          'update_existing_record': 'Update Existing Record',
          'create_new_record': 'Create New Record',
          'cancel': 'Cancel',
          'delete_calculation': 'Are you sure you want to delete this calculation?',
          'clear_all_calculations': 'Are you sure you want to delete all saved calculations? This action cannot be undone.'
        },
        'notifications': {
          'calculation_saved': 'Calculation successfully saved!',
          'calculation_updated': 'Calculation successfully updated!',
          'save_failed': 'Failed to save calculation! Please try again.',
          'calculation_deleted': 'Calculation successfully deleted!',
          'delete_failed': 'Failed to delete calculation! Please try again.',
          'all_calculations_cleared': 'All calculations successfully cleared!',
          'bulk_copy_success': 'All calculations copied to clipboard!',
          'bulk_copy_error': 'Error occurred while copying calculations!',
          'no_calculations_to_copy': 'No calculations found to copy!',
          'bulk_export_success': 'All calculations exported to Excel file!',
          'bulk_export_error': 'Error occurred while creating Excel file!',
          'no_calculations_to_export': 'No calculations found to export!',
          'room_already_exists': 'This project and room name already exists!',
          'no_results_to_save': 'No calculation results found to save!',
          'invalid_manual_selection': 'Please select a valid product and quantity!',
          'product_not_found': 'Selected product not found!',
          'calculation_cleared': 'Calculation cleared successfully!',
          'results_copied': 'Results copied to clipboard!',
          'verification_ratio_too_high': 'Doğrulama oranı çok yüksek (%150\'den fazla). Ürün sayısını azaltmayı düşünün.',
          'verification_ratio_sufficient': 'Yeterli doğrulama oranı (%100 - %124).',
          'calculation_error': 'An error occurred during calculation. Please check your input and room parameters.'
        },
        'scroll_to_saved_rooms': 'Go to saved rooms',
        'scroll_to_top': 'Go to top',
        'no_products_selected': 'No products selected',
        'no_automatic_results': 'No automatic calculation results found',
        'no_manual_products': 'No manual product selection made',
        'sufficient': 'Sufficient',
        'saved_calculations': 'Saved Calculations',
        'units': 'units',
        'safe_distance': 'Safe Distance',
        'safe_distance_human': 'Safe distance when aerosol extinguisher is directed towards a person',
        'view_details': 'View Details',
        'fire_class_a_short': 'Class A Wood',
        'no_saved_calculations': 'No saved calculations yet',
        'saved_calculation_count': '{{count}} saved rooms',
        'saved_rooms_count': 'rooms saved',
        'bulk_copy': 'Bulk Copy',
        'bulk_export': 'Bulk Excel',
        'room_details': 'Room Details',
        'close': 'Close',
        'room_name': 'Room Name',
        'dimensions': 'Dimensions',
        'adjusted_volume': 'Adjusted Volume',
        'required_extinguisher': 'Required Extinguisher',
        'selected_products': 'Selected Products',
        'total_mass': 'Total Mass',
        'validation_ratio': 'Validation Ratio',
        'unnamed_room': 'Unnamed Room',
        'unnamed_project': 'Unnamed Project',
        'calculation_date': 'Calculation Date',
        'room_properties': 'Room Properties',
        'project_info': 'Project Information',
        'region': 'Region',
        'company': 'Company',
        'control_unit': 'Control Unit',
        'load_calculation': 'Load Calculation',
        // Direk yangın sınıfı key'leri
        'wooden-stack': 'Wood Crib Fire Test',
        'a-polymer-sheet': 'Polymeric Sheet Fire Test',
        'b-nheptane-liquid': 'N-Heptane Pan Fire Test',
        'a-wooden-stack': 'Class A Compatible Wood Crib Test',
        'fire_class_options': {
          'a-wooden-stack': 'Class A Compatible Wood Crib Test',
          'b-nheptane-liquid': 'N-Heptane Pan Fire Test',
          'a-polymer-sheet': 'Polymeric Sheet Fire Test',
          'wooden-stack': 'Wood Crib Fire Test'
        },
        // Bulk copy template for English
        'bulk_copy_template': {
          'room_number': '=== ROOM {{number}} ===',
          'header': '=== ALAS FIRE CALCULATION RESULTS ===',
          'dimensions': 'Room Dimensions: {{length}}m × {{width}}m × {{height}}m',
          'volume': 'Volume: {{volume}} m³',
          'adjusted_volume': 'Adjusted Volume: {{adjusted_volume}} m³',
          'safety_factor': 'Safety Factor: {{safety_factor}}',
          'fire_class': 'Fire Class: {{fire_class}}',
          'required_mass': 'Required Extinguisher: {{required_mass}} g',
          'product_selection_header': '=== PRODUCT SELECTION ===',
          'total_extinguishers': 'Total Extinguisher Count: {{count}}',
          'total_effective_mass': 'Total Effective Mass: {{mass}} g',
          'verification_ratio': 'Verification Ratio: {{ratio}}%',
          'calculation_date': 'Calculation Date: {{date}}'
        },
        // Copy and Excel output translations
        'copyExport': {
          'calculation_results_title': 'ALAS FIRE CALCULATION RESULTS',
          'room_dimensions': 'Room Dimensions',
          'volume': 'Volume',
          'adjusted_volume': 'Adjusted Volume',
          'safety_factor': 'Safety Factor',
          'fire_class': 'Fire Class',
          'required_extinguisher': 'Required Extinguisher',
          'product_selection': 'PRODUCT SELECTION',
          'total_extinguisher_count': 'Total Extinguisher Count',
          'total_effective_mass': 'Total Effective Mass',
          'verification_ratio': 'Verification Ratio',
          'calculation_date': 'Calculation Date',
          'project': 'Project',
          'region': 'Region',
          'company': 'Company',
          'room': 'Room',
          'control_unit': 'Control Unit',
          'fire_classes': {
            'a-wooden-stack': 'Class A Compatible Wood Crib Test',
            'b-nheptane-liquid': 'N-Heptane Pan Fire Test',
            'a-polymer-sheet': 'Polymeric Sheet Fire Test',
            'wooden-stack-general': 'Wood Crib Fire Test'
          },
          'excel_titles': {
            'calculation_report': 'Calculation Report',
            'project_info': 'Project Information',
            'room_properties': 'Room Properties',
            'selected_products': 'Selected Products',
            'project_name': 'Project Name',
            'room_name': 'Room Name',
            'date': 'Date',
            'length': 'Length',
            'width': 'Width',
            'height': 'Height',
            'required_suppressant': 'Required Suppressant Amount',
            'product': 'Product',
            'quantity': 'Quantity',
            'unit_effective_mass': 'Unit Effective Mass (g)',
            'total_effective_mass': 'Total Effective Mass (g)',
            'total': 'Total',
            'suppression_capacity_control': 'Suppression Capacity Control',
            'verification_ratio': 'Verification Ratio',
            'report_footer': 'This report was generated by Alas Fire Design Calculator.',
            'summary': 'Summary'
          },
          'bulk_export': {
            'title': 'Alas Fire Bulk Calculation Report',
            'calculation_date': 'Calculation Date',
            'row_number': 'No.',
            'room_name': 'Room Name',
            'project_name': 'Project Name',
            'region': 'Region',
            'company': 'Company',
            'dimensions': 'Dimensions (m)',
            'volume': 'Volume (m³)',
            'fire_class': 'Fire Class',
            'required_amount': 'Required Amount (g)',
            'product_count': 'Product Count',
            'verification_ratio': 'Verification Ratio (%)',
            'date': 'Date'
          }
        }
      },
      'common': {
        'back': 'Back'
      },
      'privacy': {
        'title': 'Privacy Policy',
        'introduction_title': 'Introduction',
        'introduction_content': 'This Privacy Policy explains how personal information is collected, used and protected when using the Alas Design Calculator ("service") provided by ADC Makine Sanayi ve Ticaret Limited Şirketi ("Alas Fire", "we", "our"). By using this service, you accept the practices described in this policy.',
        'data_collection_title': 'Data Collection',
        'data_collection_content': 'We may collect the following information when using our service:',
        'collected_data_title': 'Collected Data:',
        'collected_data_login': 'Login information (username, password)',
        'collected_data_calculations': 'Calculation data (room dimensions, fire class, results)',
        'collected_data_usage': 'Usage data (page views, feature usage)',
        'collected_data_technical': 'Technical data (IP address, browser information, cookies)',
        'data_usage_title': 'Data Usage',
        'data_usage_content': 'Collected data is used for the following purposes:',
        'usage_service': 'Service delivery and provision of calculation results',
        'usage_security': 'Security and authentication',
        'usage_improvement': 'Service improvement and optimization',
        'usage_support': 'Technical support and customer service',
        'data_security_title': 'Data Security',
        'data_security_content': 'We use industry-standard security measures to protect your personal data. Data is transmitted over encrypted connections and stored on secure servers. However, we must note that data transmission over the internet is not 100% secure.',
        'cookies_title': 'Cookies',
        'cookies_content': 'Our service uses cookies to improve user experience:',
        'cookie_types_title': 'Cookie Types:',
        'cookie_essential': 'Essential cookies: Session management and security',
        'cookie_preferences': 'Preference cookies: Language selection and user settings',
        'cookie_analytics': 'Analytics cookies: Usage statistics (anonymous)',
        'user_rights_title': 'User Rights',
        'user_rights_content': 'Under GDPR, you have the following rights:',
        'right_access': 'Right to access your personal data',
        'right_correction': 'Right to correct incorrect data',
        'right_deletion': 'Right to delete data',
        'right_portability': 'Right to data portability',
        'right_object': 'Right to object to processing',
        'third_parties_title': 'Third Parties',
        'third_parties_content': 'We do not share your personal data with third parties. We may share limited data only with technical providers necessary for service delivery (hosting, security) and appropriate privacy agreements are signed in such cases.',
        'contact_title': 'Contact',
        'contact_content': 'You can contact us for questions or requests regarding privacy matters:',
        'updates_title': 'Policy Updates',
        'updates_content': 'This Privacy Policy may be updated when necessary. Significant changes will be notified through the service. The last update date is indicated at the bottom of the page.',
        'last_updated': 'Last Updated'
      },
      'terms': {
        'title': 'Terms of Service',
        'introduction_title': 'Introduction',
        'introduction_content': 'These Terms of Service ("Terms") govern the use of the Alas Design Calculator web application ("service") provided by ADC Makine Sanayi ve Ticaret Limited Şirketi ("Alas Fire", "company"). By using the service, you are deemed to have accepted these terms.',
        'service_definition_title': 'Service Definition',
        'service_definition_content': 'Alas Design Calculator is a specialized web application developed for Alas Fire dealers to calculate aerosol fire suppression systems.',
        'service_features_title': 'Service Features:',
        'feature_calculation': 'Extinguisher calculation based on room volume and fire class',
        'feature_product_selection': 'Product selection and optimization algorithms',
        'feature_data_storage': 'Saving calculation results',
        'feature_reporting': 'Report generation and Excel output',
        'user_account_title': 'User Account and Authentication',
        'user_account_content': 'This service can only be used by authorized Alas Fire dealers. Valid dealer credentials are required for account access.',
        'account_responsibilities_title': 'Account Responsibilities:',
        'responsibility_accuracy': 'You are responsible for the accuracy of your account information',
        'responsibility_security': 'You are obligated to keep your login information secure',
        'responsibility_unauthorized': 'You must immediately report unauthorized access',
        'responsibility_compliance': 'You must ensure compliant use of these terms',
        'service_usage_title': 'Service Usage',
        'service_usage_content': 'You may use the service only for fire suppression system calculations. The following activities are prohibited:',
        'prohibited_activities_title': 'Prohibited Activities:',
        'prohibited_unauthorized': 'Unauthorized access or use',
        'prohibited_reverse_engineer': 'Reverse engineering of software',
        'prohibited_commercial': 'Use for non-commercial purposes',
        'prohibited_malicious': 'Uploading malicious code or viruses',
        'prohibited_data_extraction': 'Automated data extraction or bots',
        'data_calculations_title': 'Data and Calculations',
        'data_calculations_content': 'Calculation results are based on EN 15276-1 and ISO 15779 standards. However, the accuracy of results depends on the entered data.',
        'important_notice_title': 'Important Warning',
        'important_notice_content': 'Calculation results are for preliminary design purposes. Professional engineering evaluation is required for final application.',
        'intellectual_property_title': 'Intellectual Property',
        'intellectual_property_content': 'All intellectual property rights of this service belong to ADC Makine Sanayi ve Ticaret Limited Şirketi. Software, algorithms, design and content are protected by copyright.',
        'disclaimer_title': 'Disclaimer',
        'disclaimer_content': 'The service is provided "as is". The company does not accept responsibility for the following matters:',
        'liability_limitations_title': 'Liability Limitations:',
        'limitation_accuracy': 'Absolute accuracy of calculation results',
        'limitation_availability': 'Uninterrupted accessibility of the service',
        'limitation_compatibility': 'Compatibility with all browsers',
        'limitation_damages': 'Indirect or consequential damages',
        'service_changes_title': 'Service Changes',
        'service_changes_content': 'The company may add, remove or modify features to improve or update the service. Significant changes will be notified to users.',
        'termination_title': 'Account Termination',
        'termination_content': 'The company reserves the right to terminate your account in the following situations:',
        'termination_conditions_title': 'Termination Conditions:',
        'termination_violation': 'Violation of terms of service',
        'termination_misuse': 'Misuse of the service',
        'termination_security': 'Security breaches',
        'termination_legal': 'Legal requirements',
        'governing_law_title': 'Governing Law',
        'governing_law_content': 'These terms are subject to the laws of the Republic of Turkey. Disputes will be resolved in Istanbul courts.',
        'contact_title': 'Contact',
        'contact_content': 'You can contact us for questions regarding these terms:',
        'changes_title': 'Changes to Terms',
        'changes_content': 'These terms may be updated when necessary. Changes are announced through the service and become effective from the effective date.',
        'last_updated': 'Last Updated',
        'version': 'Version'
      }
    }
  }
};

// i18n yapılandırması
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'tr', // Varsayılan dil Türkçe
    fallbackLng: 'tr', // Çeviri bulunamadığında kullanılacak dil
    interpolation: {
      escapeValue: false // React zaten XSS önlemi sağladığı için
    }
  });

export default i18n; 